var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___cjNjWW",
  "kL": "ChannelWelcomeSection.module__container___cjNjWW",
  "R_": "ChannelWelcomeSection.module__heading___cjNjWW",
  "h_": "ChannelWelcomeSection.module__description___cjNjWW",
  "RK": "ChannelWelcomeSection.module__iconSize___cjNjWW",
};

module.exports = exports;
